<div class="mui-alert__icon" *ngIf="icon">
  <i mui-icon font="fa" [name]="icon" data-testid="mui-alert-icon"></i>
</div>
<div class="mui-alert__content">
  <h5 class="mui-alert__content__title" *ngIf="title">{{ title }}</h5>
  <ng-content></ng-content>
</div>
<div class="mui-alert__dismiss" *ngIf="dismissible">
  <button class="mui-alert__dismiss__button" (click)="close()" [attr.aria-label]="closeButtonLabel ?? (translations$ | async)?.closeButton">
    <i mui-icon font="fa" name="times"></i>
  </button>
</div>
